import {ApplicationService} from "@hec/models";
import {SelectableSectionFragmentsService} from "./SelectableSectionFragmentsService";

export const requiredSelectableSectionFragmentsServices = (): ApplicationService[] => {
  return [
    new SelectableSectionFragmentsService()
  ];
}
